<template>
  <!-- 详情弹框 -->
  <div class="Detailsbox">
    <div class="userbox">
      <div class="userbox_topbox">
        <img class="usertopbox_img1" src="@/assets/images/system/Users/titleguoducolor.png" alt="" />
        <div class="usertopbox_title">{{ showtitle }}</div>
        <img class="usertopbox_img2" src="@/assets/images/system/Users/zdelete.png" alt="" @click="userqx()" />
      </div>
      <div class="borderbottom borderbottom1"></div>
      <div class="userbox_bodybox">
        <div class="userbox_bodybox_flexbox">
          <div class="userbodybox_inputbox">
            <el-upload :class="[
              'avatar-uploader',
              json.avatarUrl ? '' : 'avatar-uploaderunac',
            ]" :disabled='ckxqstatus == 1' action='' accept='.jpg,.jpeg,.png' :http-request='uploadAvatar'
              :show-file-list="false" :before-upload="beforeAvatarUpload">
              <img v-if="json.avatarUrl" :src="json.showavatarUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="userbodybox_inputbox">
            <div class="tinputname"><span>*</span>用户名</div>
            <el-input @change="username_change" :class="['tinput', json_usershow == false ? 'tinput_sb' : '']"
              :disabled="ckxqstatus == 1 || ckxqstatus == 2" v-model="json.username" placeholder="请输入内容"></el-input>
            <transition>
              <div v-show="json_usershow === false" class="showtitle_sb">
                用户名已存在
              </div>
            </transition>
          </div>
          <div class="userbodybox_inputbox">
            <div class="tinputname"><span>*</span>中文名</div>
            <el-input class="tinput" v-model="json.chnname" :disabled="ckxqstatus == 1" placeholder="请输入内容"></el-input>
          </div>
          <div class="userbodybox_inputbox userbodybox_inputboxmr0">
            <div class="tinputname"><span>*</span>部门</div>
            <Treeselect :disabled="ckxqstatus == 1" class="Treeselect_dis" v-model="json.deptId" :options="options"
              :show-count="true" placeholder="请选择您的部门" />
          </div>
          <div class="userbodybox_inputbox">
            <div class="tinputname">员工状态</div>
            <el-select :disabled="ckxqstatus == 1" v-model="json.status" placeholder="请选择">
              <el-option v-for="item in optionsstatus" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="userbodybox_inputbox">
            <div class="tinputname"><span>*</span>身份证</div>
            <el-input :class="['tinput', json_idCardshow == false ? 'tinput_sb' : '']" :disabled="ckxqstatus == 1"
              v-model="json.idCard" placeholder="请输入内容"></el-input>
            <transition>
              <div v-show="json_idCardshow == false" class="showtitle_sb">
                身份证格式输入错误
              </div>
            </transition>
          </div>
          <div class="userbodybox_inputbox">
            <div class="tinputname"><span>*</span>性别</div>
            <el-select :disabled="ckxqstatus == 1" v-model="json.sex" placeholder="请选择">
              <el-option v-for="item in optionsxb" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="userbodybox_inputbox userbodybox_inputboxmr0">
            <div class="tinputname"><span>*</span>手机号</div>
            <el-input :class="['tinput', json_mobileshow !== true ? 'tinput_sb' : '']" :disabled="ckxqstatus == 1"
              v-model="json.mobile" placeholder="请输入内容"></el-input>
            <transition>
              <div v-show="json_mobileshow === 1" class="showtitle_sb">
                手机号格式输入错误
              </div>
            </transition>
            <transition>
              <div v-show="json_mobileshow === 2" class="showtitle_sb">
                手机号已注册
              </div>
            </transition>
            <transition>
              <div v-show="json_mobileshow === 3" class="showtitle_sb">
                检查手机号重复接口请求超时
              </div>
            </transition>
          </div>
          <div class="userbodybox_inputbox userbodybox_inputbox_big">
            <div class="tinputname">家庭住址</div>
            <el-input class="tinput" :disabled="ckxqstatus == 1" v-model="json.address" placeholder="请输入内容"></el-input>
          </div>
          <div class="userbodybox_inputbox">
            <div class="tinputname">邮箱</div>
            <el-input :class="['tinput', json_emailshow == false ? 'tinput_sb' : '']" :disabled="ckxqstatus == 1"
              v-model="json.email" placeholder="请输入内容"></el-input>
            <transition>
              <div v-show="json_emailshow == false" class="showtitle_sb">
                邮箱格式输入错误
              </div>
            </transition>
          </div>
          <div class="userbodybox_inputbox userbodybox_inputboxmr0">
            <div class="tinputname">职位</div>
            <el-input class="tinput" :disabled="ckxqstatus == 1" v-model="json.position" placeholder="请输入内容"></el-input>
          </div>
          <div class="userbodybox_inputbox">
            <div class="tinputname"><span>*</span>政治面貌</div>
            <el-select :disabled="ckxqstatus == 1" v-model="json.politicalExperience" placeholder="请选择">
              <el-option v-for="item in options_party" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="userbodybox_inputbox">
            <div class="tinputname"><span>*</span>学历</div>
            <el-select :disabled="ckxqstatus == 1" v-model="json.educationalBackground" placeholder="请选择">
              <el-option v-for="item in options_degree" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="userbodybox_inputbox">
            <div class="tinputname"><span>*</span>岗位</div>
            <el-select :disabled="ckxqstatus == 1" v-model="json.jobNature" placeholder="请选择">
              <el-option v-for="item in options_jobNature" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="userbodybox_inputbox userbodybox_inputboxmr0">
            <div class="tinputname"><span>*</span>在岗状态</div>
            <el-select :disabled="ckxqstatus == 1" v-model="json.onDutyStatus" placeholder="请选择">
              <el-option v-for="item in options_DutyStatus" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="userbodybox_inputbox">
            <div class="tinputname"><span>*</span>入职日期</div>
            <el-date-picker v-model="json.entryDate" type="date" :disabled="ckxqstatus == 1" placeholder="选择日期"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
          <div class="userbodybox_inputbox">
            <div class="tinputname"><span>*</span>行政区划</div>
            <el-cascader v-model="json.areaNumber" :disabled="ckxqstatus == 1" :options="options_areaNumber"
              placeholder="请选择" filterable>
            </el-cascader>
          </div>
          <div class="userbodybox_inputbox">
            <div class="tinputname"><span>*</span>民族</div>
            <el-select :disabled="ckxqstatus == 1" v-model="json.ethnicity" placeholder="请选择">
              <el-option v-for="item in options_group" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="userbodybox_inputbox userbodybox_inputboxmr0">
            <div class="tinputname">排序号</div>
            <el-input-number :disabled="ckxqstatus == 1" v-model="json.sort" step-strictly :step="1" :min="1" :max="999"
              label="描述文字"></el-input-number>
          </div>
        </div>
      </div>
      <div class="borderbottom borderbottom2" v-show="ckxqstatus != 1"></div>
      <div class="userbox_fotbox" v-show="ckxqstatus != 1">
        <el-button size="small" @click="userbc()" class="userbox_but" type="primary" v-loading="loading"
          :element-loading-background="config.loading.background">保存</el-button>
        <el-button size="small" @click="userqx()" class="userbox_but">取消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { httpToken } from "@/utils/http";
import qs from "qs";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { checkisnull, getXialaListdata,objdata_set } from "@/utils/util";
import { fileUpload } from "@/utils/upload";
import { imgshow2 } from "@/api/file";
import { getSexData, getPartyData, getDegreeData, getjobNatureData, getonDutyStatusData, getgroupData } from "@/utils/server/selectdata"
import { CodeToText, regionData } from "element-china-area-data";
export default {
  components: { Treeselect },
  props: {
    showtitle: {
      type: String,
      default: '个人信息修改'
    },
    // 详情弹窗状态 1为详情 2为编辑  3新增 4为关闭
    ckxqstatus: {
      type: Number,
      default: 2
    }
  },
  watch: {
    "json.idCard": {
      handler(newName) {
        if (this.ckxqstatus != 1) {
          if (newName == "" || newName == null) {
            this.json_idCardshow = true;
          } else {
            let pattern =
              /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
            this.json_idCardshow = this.passwordyz(newName, pattern);
          }
        }
      },
    },
    "json.mobile": {
      handler(newName) {
        // json_mobileshow true 通过  1手机号格式输入错误 2手机号已注册
        if (this.ckxqstatus != 1) {
          if (newName == "" || newName == null) {
            this.json_mobileshow = true;
          } else {
            let pattern =
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
            if (this.passwordyz(newName, pattern)) {
              if (this.ckxqstatus == 2) {
                this.check_mobile(newName, this.nowusername);
              } else {
                this.check_mobile(newName);
              }
            } else {
              this.json_mobileshow = 1;
            }
          }
        }
      },
    },
    "json.email": {
      handler(newName) {
        if (this.ckxqstatus != 1) {
          if (newName == "" || newName == null) {
            this.json_emailshow = true;
          } else {
            let pattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
            this.json_emailshow = this.passwordyz(newName, pattern);
          }
        }
      },
    },
    deep: true,
  },
  data() {
    return {
      loading: false,
      // 弹窗部门下拉选择
      options: [],
      // 性别下拉选择
      optionsxb: getSexData(),
      // 员工状态
      optionsstatus: [
        { value: 0, label: "禁用" },
        { value: 1, label: "正常" },
      ],
      options_party: getPartyData(),//政治面貌下拉数据
      options_degree: getDegreeData(),//学历下拉数据
      options_jobNature: getjobNatureData(),//岗位下拉数据
      options_DutyStatus: getonDutyStatusData(),//在岗状态下拉数据
      options_group: getgroupData(),//获取民族下拉数据
      options_areaNumber: regionData,//获取行政区下拉数据
      // 弹窗信息
      json: {},
      // 身份证判断
      json_idCardshow: true,
      json_mobileshow: true,
      json_emailshow: true,
      json_usershow: true,
      // 当前编辑人名称
      nowusername: '',
      roleshow: true,//是否有角色权限
    };
  },
  mounted() {
    this.userqikong();
    this.getdeptTree();
  },
  methods: {
    getjson(val) {
      this.nowusername = val.username
      this.userqikong();
      this.json = objdata_set(this.json,val)
      if(this.json.areaNumber){
        this.json.areaNumber=this.json.areaNumber.split(',')
      }
      this.json.showavatarUrl = ''
      if (val.avatarUrl) {
        imgshow2(val.avatarUrl).then(res => {
          this.json.showavatarUrl = "data:image/jpeg;base64," + res.data.data
        })
      }
      if (this.ckxqstatus == 2) {
        this.json.id = val.id;
      }
    },
    // 验证角色重名
    username_change(val) {
      if (this.ckxqstatus == 3) {
        httpToken({
          method: "post",
          url: "/sys-user/checkUsername",
          data: qs.stringify({
            unitId: JSON.parse(sessionStorage.user).unitId,
            username: val,
          }),
          timeout: 1000
        }).then((res) => {
          if (res.data.code == 200) {
            this.json_usershow = true;
          } else {
            this.json_usershow = false;
          }
        }).catch((err) => {
          if (String(err).indexOf('timeout') != -1) {
            this.json_usershow = false;
          }
        })
      }
    },
    getdeptTree() {
      let that = this;
      httpToken({
        method: "post",
        url: "/sys-dept/findDeptTree",
      }).then((res) => {
        if (res.data.code == 200) {
          that.options = that.diGuiTreeEdit(res.data.data);
        }
      });
    },
    diGuiTreeEdit(item, compID) {
      // 编辑情况下，禁止选择当前节点及其子节点
      let data = item;
      let treeAry = [];
      for (let i in data) {
        let v = data[i];
        let node = {};
        if (v === null || v === undefined) {
          console.log("diGuiTreeEdit信息暂无");
        } else {
          if (v.children && v.children.length > 0) {
            if (v.id == compID) {
              node.isDisabled = true;
            } else {
              node.isDisabled = false;
            }
            node.id = v.id;
            node.label = v.label;
            node.name = v.name;
            node.children = this.diGuiTreeEdit(v.children, compID);
            treeAry.push(node);
          } else {
            if (v.id == compID) {
              node.isDisabled = true;
            } else {
              node.isDisabled = false;
            }
            node.id = v.id;
            node.label = v.label;
            node.name = v.name;
            treeAry.push(node);
          }
        }
      }
      return treeAry;
    },
    // 验证手机号
    check_mobile(val, name) {
      let data = {
        mobile: val
      }
      if (name) {
        data.username = name;
      }
      httpToken({
        method: "post",
        url: "/sys-user/checkMobile",
        data: qs.stringify(data),
        timeout: 1000
      }).then((res) => {
        if (res.data.code == 200) {
          // json_mobileshow true 通过  1手机号格式输入错误 2手机号已注册  3超时
          this.json_mobileshow = true;
        } else {
          this.json_mobileshow = 2;
        }
      }).catch((err) => {
        if (String(err).indexOf('timeout') != -1) {
          this.json_mobileshow = 3;
        }
      })
    },
    passwordyz(val, creg) {
      // 至少8个字符，至少1个大写字母，1个小写字母和1个数字：
      let reg = new RegExp("^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$");
      if (creg) {
        reg = creg;
      }
      return reg.test(val);
    },
    uploadAvatar(file) {
      fileUpload.uploadFunc(1, file.file, 'user_avatarUrl', (res) => {
        let resdata = res.data.data;
        if (res.data.code == 200) {
          imgshow2(resdata[0].fileUrl).then(res => {
            this.json.avatarUrl = resdata[0].fileUrl;
            this.json.showavatarUrl = "data:image/jpeg;base64," + res.data.data
          })
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG或png 格式!');
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M && isJPG;
    },
    // 清空人员弹窗数据
    userqikong() {
      this.json = {
        address: "",
        avatarUrl: "",//下载的头像路径
        showavatarUrl: "",//展示的头像路径
        chnname: "",
        deptId: null,
        email: "",
        idCard: "",
        mobile: "",
        position: "",
        sex: 1,
        status: 1,
        username: "",
        sort: 1,
        politicalExperience: '13',//政治面貌
        educationalBackground: '1',//学历
        areaNumber: '',//行政区划代码
        entryDate: '',//入职日期
        jobNature: '11',//岗位性质
        onDutyStatus: '01',//在岗状态
        ethnicity: '01',//民族
      };
      this.json_idCardshow = true;
      this.json_mobileshow = true;
      this.json_emailshow = true;
      this.json_usershow = true;
    },
    // 弹窗 保存 // <!-- // ckxqstatus 详情弹窗状态 1为详情 2为编辑  3新增 4为关闭 -->
    userbc() {
      let that = this;
      let json = JSON.parse(JSON.stringify(this.json));
      if (checkisnull(json.username)) {
        this.$message({
          message: "名称不能为空",
          type: "warning",
        });
        return;
      }
      if (checkisnull(json.deptId)) {
        this.$message({
          message: "部门不能为空",
          type: "warning",
        });
        return;
      }
      if (checkisnull(json.chnname)) {
        this.$message({
          message: "中文名不能为空",
          type: "warning",
        });
        return;
      }
      if (checkisnull(json.idCard)) {
        this.$message({
          message: "身份证不能为空",
          type: "warning",
        });
        return;
      }
      if (checkisnull(json.mobile)) {
        this.$message({
          message: "手机号不能为空",
          type: "warning",
        });
        return;
      }
      if (checkisnull(json.sort)) {
        this.$message({
          message: "排序号不能为空",
          type: "warning",
        });
        return;
      }
      if (
        this.json_idCardshow == false ||
        this.json_mobileshow === 1 ||
        this.json_emailshow == false
      ) {
        this.$message({
          message: "身份证、手机号或者邮箱格式输入错误",
          type: "warning",
        });
        return;
      }
      if (
        this.json_mobileshow === 2
      ) {
        this.$message({
          message: "手机号已注册",
          type: "warning",
        });
        return;
      }
      if (
        this.json_mobileshow === 3
      ) {
        this.$message({
          message: "检查手机号重复接口请求超时",
          type: "warning",
        });
        return;
      }
      if (this.json_usershow == false) {
        this.$message({
          message: "用户名已存在",
          type: "warning",
        });
        return;
      }
      if (checkisnull(json.entryDate)) {
        this.$message({
          message: "请选择入职日期",
          type: "warning",
        });
        return;
      }
      if (checkisnull(json.areaNumber)) {
        this.$message({
          message: "请选择行政区划",
          type: "warning",
        });
        return;
      }
      json.areaNumber=String(json.areaNumber)
      this.loading = true
      if (this.ckxqstatus == 3) {
        httpToken({
          method: "post",
          url: "/sys-user/add",
          data: json,
        }).then((res) => {
          if (res.data.code == 200) {
            that.$message({
              message: "添加成功",
              type: "success",
            });
            that.$emit('getdatalbEmit')
          }
          this.loading = false
          this.userqx()
        }).catch(() => {
          this.loading = false;
          this.userqx()
        })
      } else if (this.ckxqstatus == 2) {
        httpToken({
          method: "post",
          url: "/sys-user/update",
          data: json,
        }).then((res) => {
          if (res.data.code == 200) {
            that.$message({
              message: "修改成功",
              type: "success",
            });
            that.$emit('getdatalbEmit')
            // 修改登录人信息重置
            if (json.id == JSON.parse(sessionStorage.getItem('user')).id) {
              let resdata = res.data.data;
              sessionStorage.setItem('user', JSON.stringify(resdata))
              this.$store.commit("setuserstate");
            }
          }
          this.loading = false;
          this.userqx()
        }).catch(() => {
          this.loading = false;
          this.userqx()
        })
      }
    },
    // 弹窗 取消
    userqx() {
      this.$emit("showidemit");
    },

  },
};
</script>
<style scoped lang="scss">
@import "@/assets/css/system/user.scss";

.Detailsbox {
  line-height: normal !important;
}
::v-deep .el-date-editor.el-input{
  width: 100%;
}
</style>
